import { h } from 'preact';

const CartItemSkeleton = () => (
  <div className="flex gap-5 py-5 lg:mb-5 border-[#F4F1E6] border-b-[1px] border-solid md:last-of-type:border-none">
    <div className="w-[120px] max-w-[120px] min-w-[120px] md:w-1/3 h-[180px] bg-gray-200"></div>
    <div className="details md:w-full">
      <div className="flex justify-between gap-3">
        <span className="h7--medium md:text-sm text-text-default w-[140px] h-[20px] bg-gray-200"></span>
        <p className="flex gap-1 md:text-sm bg-gray-200 h-[20px] w-[31px]"></p>
      </div>
      <a className="no-underline body-3 md:text-sm text-text-default bg-gray-200 w-[200px] h-[17.5px]"></a>
      <div className="mt-2.5 md:mt-5">
        <p className="body-3 text-text-default md:text-sm bg-gray-200 h-[20px] w-[150px]"></p>
        <p className="body-3 text-text-default md:text-sm bg-gray-200 h-[20px] w-[150px]"></p>
      </div>
      <button className="flex bg-core-1 justify-between items-center py-1.5 px-2 gap-12 mt-2.5 lg:mt-5 w-[192px] h-[31.2px]"></button>
      <div className="flex items-center mt-2.5 laptop:mt-0 laptop:basis-[39%] laptop:items-start laptop:mt-0 laptop:justify-center laptop:pl-[3%] w-[145px] bg-gray-200 h-[38px]">
        <div className="flex border border-border-gray font-r-18 laptop:px-2"></div>
        <button className="text-xs underline text-default ml-5"></button>
      </div>
      <button className="text-xs md:text-sm mt-5 md:mt-6 underline underline-offset-[2.5px] text-default bg-gray-200 w-[112px] h-[20px]"></button>
    </div>
  </div>
);

const MiniCartSkeleton = () => (
  <div className="cart-popup  overflow-hidden flex-grow max-h-[calc(100%-170px)] lg:max-h-none bg-white">
    <div className="p-5">
      <CartItemSkeleton />
      <CartItemSkeleton />
      <CartItemSkeleton />
    </div>
  </div>
);

export default MiniCartSkeleton;
